/* eslint-disable no-unused-vars */
import * as yup from 'yup';

function checkString(str) {
  //eslint-disable-next-line
  const regex = /[!\$^*()+|~`{}\[\]\\:;"'<>,\s]/;
  return !regex.test(str);
}
function checkParams(params) {
  const { state } = this.parent;
  const { path } = this;
  if (!state) return true;
  const isPostBackParam = path.includes('$appnext_postbackparams$');
  if (isPostBackParam && state && !params) return false;
  return checkString(params);
}

const showErrorMessageParameters = (flag) => {
  const res = {
    isRequired: 'It is a required field',
    wrongSumbol: 'Space and the following symbols are not allowed: "[]!$^*()+|~`{}\\";\'<>,',
  };
  const isPostBackParam = flag.path.includes('$appnext_postbackparams$');
  if (isPostBackParam && !flag.value) return res.isRequired;
  else return res.wrongSumbol;
};

const setUniqueElementToPosition = () => {
  const commonFields = [
    '$appnext_postbackparams$',
    '$appnext_postbackandropackage$',
    '$appnext_deviceid$',
    '$appnext_userip$',
    '$appnext_placementid$',
  ];
  return (newField, index) => {
    if (index < 0 || index > commonFields.length) {
      return [...commonFields, newField];
    }
    return [...commonFields.slice(0, index), newField, ...commonFields.slice(index)];
  };
};

const getPostBackFields = setUniqueElementToPosition();

export const installPostBackFields = getPostBackFields('$appnext_postbackrevenue$', 1);
export const eventPostBackFields = getPostBackFields('$appnext_eventname$', 1);
export const rejectedInstallPostbackFields = getPostBackFields('$appnext_rejectedreason$', 1);

const generatePostbackSchema = (fields) => {
  const schema = {};
  fields.forEach((field) => {
    schema[field] = yup.string().test(field, (d) => showErrorMessageParameters(d), checkParams);
  });
  return yup.object(schema);
};

const createPostBackSchema = (sectionFields) => {
  const fields = {
    baseUrl: yup
      .string()
      .url('URL is not correct')
      .test(
        'no-multiple-question-marks',
        'Use "&" instead of "?" to separate query parameters',
        function (baseUrl) {
          const { state } = this.parent;
          if (!state) return true;
          if (!baseUrl) return true;
          const firstQMark = baseUrl.indexOf('?');
          if (firstQMark === -1) return true;
          return !baseUrl.substring(firstQMark + 1).includes('?');
        },
      )
      .test('installPostBack.baseUrl', 'Please enter a valid URL', function (baseUrl) {
        const { state } = this.parent;
        if (!state) return true;
        if (state && !baseUrl) return false;
        return true;
      }),
    ...generatePostbackSchema(sectionFields).fields,
  };
  return yup.object(fields);
};

export const postBackSchema = yup.object({
  installPostBack: createPostBackSchema(installPostBackFields),
  eventPostBack: createPostBackSchema(eventPostBackFields),
  rejectedInstallPostBack: createPostBackSchema(rejectedInstallPostbackFields),
});
